import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WkcAssetRestitution from '@/types/table/wkcAssetRestitution';
import { WkcAssetRestitutionDetailData } from '@/api/generated/wkcAssetRestitutionDetailController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WkcAssetRestitutionData extends WkcAssetRestitution {
  wkcAssetRestitutionDetailList?: WkcAssetRestitutionDetailData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class WkcAssetRestitutionController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcAssetRestitutionData>>(API_CONTEXT + '/app/wkcAssetRestitution/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WkcAssetRestitutionData>(API_CONTEXT + '/app/wkcAssetRestitution/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/wkcAssetRestitution/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/wkcAssetRestitution/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/wkcAssetRestitution/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcAssetRestitution/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcAssetRestitution/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcAssetRestitution/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcAssetRestitution/deleteBatch', params, httpOptions);
  }
  static startOnlyWkcAssetRestitution(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcAssetRestitution/startOnly/wkcAssetRestitution', params, httpOptions);
  }
  static startWithBusinessKeyWkcAssetRestitution(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcAssetRestitution/startWithBusinessKey/wkcAssetRestitution', params, httpOptions);
  }
  static startAndTakeUserTaskWkcAssetRestitution(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcAssetRestitution/startAndTakeUserTask/wkcAssetRestitution', params, httpOptions);
  }
  static startAndSaveDraftWkcAssetRestitution(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcAssetRestitution/startAndSaveDraft/wkcAssetRestitution', params, httpOptions);
  }
  static submitUserTaskWkcAssetRestitution(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcAssetRestitution/submitUserTask/wkcAssetRestitution', params, httpOptions);
  }
  static viewTaskBusinessDataWkcAssetRestitution(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcAssetRestitution/viewTaskBusinessData/wkcAssetRestitution', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataWkcAssetRestitution(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/wkcAssetRestitution/viewHistoricTaskBusinessData/wkcAssetRestitution', params, httpOptions);
  }
  static listWorkOrderWkcAssetRestitution(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcAssetRestitution/listWorkOrder/wkcAssetRestitution', params, httpOptions);
  }

  static cancelWorkOrders(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/wkcAssetRestitution/cancelWorkOrder', params, httpOptions);
  }
    static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }

  static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WkcAssetRestitutionData>>(API_CONTEXT + '/app/dept/getUserInformation', params, httpOptions);
  }

}
